import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import {
  HvGlobalActions,
  HvButton,
  HvScrollToHorizontal,
} from "@hitachivantara/uikit-react-core";
import { Backwards } from "@hitachivantara/uikit-react-icons";

import { OverflowTooltip } from "components/common";

import useStyles from "./styles";

export interface FormSection {
  label: string;
  value: string;
}

const FormHeader: React.FC<{
  title: string | React.ReactNode;
  sections: FormSection[];
  onCancel: () => void;
  children?: React.ReactNode;
}> = (props) => {
  const { t } = useTranslation("common");

  const { title, sections, onCancel, children } = props;

  const classes = useStyles();

  const onBackHandler = () => {
    onCancel();
  };

  const BackButton = () => (
    <HvButton aria-label={t("formHeader.back")} icon onClick={onBackHandler}>
      <Backwards />
    </HvButton>
  );

  return (
    <>
      <HvGlobalActions
        className={classes.zIndex}
        title={
          typeof title === "string" ? (
            <OverflowTooltip data={title} className={clsx(classes.title)} />
          ) : (
            title
          )
        }
        backButton={<BackButton />}
      >
        {children}
      </HvGlobalActions>
      <HvScrollToHorizontal
        className={clsx(classes.scrollTo, classes.zIndex)}
        options={sections}
        position="sticky"
        classes={{
          root: classes.scrollToRoot,
          positionSticky: classes.scrollToSticky,
        }}
        offset={100}
        href={false}
        scrollElementId="wis-container"
      />
    </>
  );
};

export default FormHeader;
